import { StompSocket } from "project-config/services";
import { isDev } from "project-config//utils/env";
import { Cookie } from "project-config/utils";
import { STORAGE } from "project-config/constants";

export class TaskSocket {
  stompClient: StompSocket = null;
  serverUrl: string = "";
  subscribeDestination: string = "/user/topic/msg";
  allUserDestination: string = "/topic/msg";
  userId: number = 0;
  hasInitialized = false;
  onMessageCallback = () => {};
  constructor(props?: { serverUrl?: string; subscribeDestination?: string }) {
    if (props) {
      this.serverUrl = props.serverUrl;
      this.subscribeDestination = props.subscribeDestination;
    }
  }

  init({ userKey, userId }: { userKey?: string; userId: number }) {
    const localUserKey = Cookie.getCookie(STORAGE.RAYVISION_USERKEY);
    Cookie.setCookie(STORAGE.RAYVISION_USERKEY, userKey || localUserKey);
    const serverUrl = `wss://${
      isDev() ? "task-pre" : "task"
    }.renderbus.com/websocket?userKey=${userKey || localUserKey}`;
    this.stompClient = new StompSocket(this.serverUrl || serverUrl);
    this.userId = userId;
    this.hasInitialized = true;
    return this;
  }

  send(destination: string) {
    if (!this.stompClient) {
      return;
    }
    this.stompClient.send(destination);
  }

  onMessage(callback: (frameObject: { body: string }) => void) {
    const userKey = Cookie.getCookie(STORAGE.RAYVISION_USERKEY);
    this.onMessageCallback = callback;
    this.stompClient.connect(
      {
        userKey,
      },
      () => {
        this.stompClient.send(`/rendering/message/greeting.${this.userId}`);
      },
      () => {
        this.stompClient.subscribe(this.subscribeDestination, callback);
        this.stompClient.subscribe(this.allUserDestination, callback);
      },
      () => {
        this.init({ userId: this.userId }).onMessage(this.onMessageCallback);
      }
    );
  }

  destroy() {
    this.stompClient?.unSubscribe();
  }
}
